import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Companies from "@/pages/Companies";
import Deals from "@/pages/Deals";
import Funnels from "@/pages/Funnels";
import Tasks from "@/pages/Tasks";
import Admin from "@/pages/Admin";
import CalendarPage from "@/pages/CalendarPage";
import AuditLogs from "@/pages/AuditLogs";
import ServiceAudit from "@/pages/ServiceAudit";
import AIUsage from "@/pages/AIUsage";
import WeeklyControl from "@/pages/WeeklyControl";
import ShareTarget from "@/pages/ShareTarget";
import ScanCard from "@/pages/ScanCard";
import Profile from "@/pages/Profile";
import MyCard from "@/pages/MyCard";
import ShareCard from "@/pages/ShareCard";
import VirtualCard from "@/pages/VirtualCard";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

function AppRouter() {
    const location = useLocation();
    // CRITICAL: detect session_id during render before any other route handles it
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute permission="dashboard"><Dashboard /></ProtectedRoute>} />
            <Route path="/leads" element={<ProtectedRoute permission="contacts_view"><Leads /></ProtectedRoute>} />
            <Route path="/companies" element={<ProtectedRoute permission="companies_view"><Companies /></ProtectedRoute>} />
            <Route path="/deals" element={<ProtectedRoute permission="deals_view"><Deals /></ProtectedRoute>} />
            <Route path="/funnels" element={<ProtectedRoute permission="funnels_view"><Funnels /></ProtectedRoute>} />
            <Route path="/tasks" element={<ProtectedRoute permission="tasks_view"><Tasks /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute permission="calendar_view"><CalendarPage /></ProtectedRoute>} />
            <Route path="/service-audit" element={<ProtectedRoute permissions={["service_financial_view", "service_weekly_audit_view", "service_backups_view", "code_security_view"]}><ServiceAudit /></ProtectedRoute>} />
            <Route path="/weekly-control" element={<ProtectedRoute permission="weekly_control_view"><WeeklyControl /></ProtectedRoute>} />
            <Route path="/ai-usage" element={<ProtectedRoute permission="ai_usage"><AIUsage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute permission="admin"><Admin /></ProtectedRoute>} />
            <Route path="/audit" element={<ProtectedRoute permission="audit"><AuditLogs /></ProtectedRoute>} />
            <Route path="/namedrop/share-target" element={<ProtectedRoute permission="contacts_manage"><ShareTarget /></ProtectedRoute>} />
            <Route path="/scan-card" element={<ProtectedRoute permission="contacts_manage"><ScanCard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/my-card" element={<ProtectedRoute><MyCard /></ProtectedRoute>} />
            <Route path="/share-card" element={<ProtectedRoute><ShareCard /></ProtectedRoute>} />
            <Route path="/c/:identifier" element={<VirtualCard />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRouter />
                <PWAInstallPrompt />
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
